import React from "react"
import { useStore } from "../../teafuljs/store"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import DialogContent from "@material-ui/core/DialogContent"
import SourceViewInfo from "../SourceViewInfo/SourceViewInfo"
import Typography from "@material-ui/core/Typography"
import SVBLogo from "../../../static/images/SVLogo.jpeg"
import { getTranslation } from "../../scripts/getTranslation"

import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
  typography: {
    padding: theme.spacing(2),
    fontSize: "small",
    color: "white",
  },
  definition: {
    fontWeight: "bold",
  },
  dialogRef: {
    color: "grey",
    fontSize: "80%",
    textAlign: "center",
    marginBottom: "-15px",
  },
  dialogHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "-10px",
  },
  logo: {
    height: "30px",
    width: "auto",
  },
  SVicons: {
    height: "50px",
    width: "50px",
    marginRight: "5px",
    marginBottom: "5px",
  },
  dialogTitle: {
    display: "flex",
    flexWrap: "nowrap",
    justifyContent: "space-between",
  },
  dialogContent: {
    display: "flex",
    justifyContent: "center",
  },
  title: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  svbInfo: {
    position: "relative",
    width: "100%",
  },
  closeButtonHolder: {
    margin: 0,
    padding: 0,
    width: "30px",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}))

const SourceViewDialog = props => {
  const translations = useStore.translations()[0]
  const language = useStore.language()[0]
  const classes = useStyles()
  return (
    <Dialog
      maxWidth="lg"
      style={{ maxWidth: 550, maxHeight: 900, margin: "0 auto" }}
      open={props.sourceViewDialog.open}
      onClose={() => props.newSourceViewDialog({ open: false, content: {} })}
    >
      <DialogTitle>
        <div className={classes.dialogTitle}>
          <img
            src={SVBLogo}
            className={classes.SVicons}
            alt="SourceView Logo"
          />
          <div className={classes.title}>
            <Typography variant="h5">
              {getTranslation(
                translations,
                language,
                "UI",
                "sourceview_popup_title"
              )}
            </Typography>
          </div>
          <div className={classes.closeButtonHolder}>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={props.onClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </div>
      </DialogTitle>
      <DialogContent dividers className={classes.dialogContent}>
        <SourceViewInfo
          className={classes.svbInfo}
          content={props.sourceViewDialog.content}
          close={() => props.newSourceViewDialog({ open: false, content: {} })}
        />
      </DialogContent>
    </Dialog>
  )
}

export default SourceViewDialog
